import { Component, Input } from '@angular/core';
import { BtnType } from '../../type/btnType.type';

@Component({
  selector: 'app-floating-action-button',
  templateUrl: './floating-action-button.component.html',
  styleUrls: ['./floating-action-button.component.scss'],
})
export class FloatingActionButtonComponent {
  @Input('type') type: BtnType = 'button';
  @Input('color') color: string = 'primary';
  @Input('icon') icon: string = 'add';
  @Input('title') title: string = 'Aktion';
  @Input('content-type') contentType: string = 'wide';
}
